import { useEffect, useState } from 'react';

export function useIntervalTick(intervalMs: number) {
	const [tick, setTick] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setTick((prev) => prev + 1);
		}, intervalMs);

		return () => clearInterval(interval);
	}, [intervalMs]);

	return tick;
}
